if (!customElements.get('quick-add-modal')) {
    customElements.define(
        'quick-add-modal',
        class QuickAddModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            }

            hide(preventFocus = false) {
                const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if (cartNotification) cartNotification.setActiveElement(this.openedBy);
                this.modalContent.innerHTML = '';

                if (preventFocus) this.openedBy = null;
                super.hide();
            }

            show(opener) {
                opener.setAttribute('aria-disabled', true);
                opener.classList.add('loading');
                opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

                fetch(opener.getAttribute('data-product-url'))
                    .then((response) => response.text())
                    .then((responseText) => {
                        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                        this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
                        this.preventDuplicatedIDs();
                        this.removeDOMElements();
                        this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        if (window.ProductModel) window.ProductModel.loadShopifyXR();

                        this.removeGalleryListSemantic();
                        this.updateImageSizes();
                        this.preventVariantURLSwitching();

                        // ✅ ADD: run after setting content
                        this.initVariantListeners();

                        super.show(opener);
                    })
                    .finally(() => {
                        opener.removeAttribute('aria-disabled');
                        opener.classList.remove('loading');
                        opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    });
            }

            setInnerHTML(element, html) {
                element.innerHTML = html;

                // Reinject <script> tags
                element.querySelectorAll('script').forEach((oldScriptTag) => {
                    const newScriptTag = document.createElement('script');
                    Array.from(oldScriptTag.attributes).forEach((attribute) => {
                        newScriptTag.setAttribute(attribute.name, attribute.value);
                    });
                    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                });

                // Extra element hiding (optional)
                element.querySelectorAll('.product__media-wrapper,.shopify-app-block,.size-chat-wrap,.product-types, .tieroffers,' +
                    ' #review-open-fix,' +
                    ' .product__view-details').forEach(function (element) {
                    element.style.display = 'none';
                });

                // Layout restructure (optional)
                var productTitle = element.querySelector('.product__title');
                var productVendor = element.querySelector('.product-vendor-js');
                var rating = element.querySelector('.shopify-price-block');
                var mediaContent = element.querySelector('.product__media.media');

                var newDiv = document.createElement('div');
                newDiv.className = 'quick-title-price-wrap';

                var contentDiv = document.createElement('div');
                contentDiv.className = 'quick-title-price-content';

                var parent = productTitle.parentNode;
                parent.insertBefore(newDiv, productTitle);

                if (mediaContent) newDiv.appendChild(mediaContent);
                contentDiv.appendChild(productTitle);
                if (productVendor) contentDiv.appendChild(productVendor);
                contentDiv.appendChild(rating);
                newDiv.appendChild(contentDiv);
            }

            initVariantListeners() {
                const variantRadios = this.modalContent.querySelector("#variant-radios");
                const selectVariantButtons = this.modalContent.querySelectorAll(".js-select-variant");
                const productDrawer = document.getElementById("product-drawer-js");

                if (variantRadios) {
                    variantRadios.addEventListener("click", () => {
                        selectVariantButtons.forEach((btn) => {
                            btn.style.display = "none";
                        });
                        variantRadios.classList.add("variant-radios-checked");
                    });
                }

                selectVariantButtons.forEach((btn) => {
                    btn.addEventListener("click", () => {
                        if (variantRadios) variantRadios.classList.add("has-active");
                        if (productDrawer) productDrawer.classList.add("has-active");
                    });
                });
            }

            preventVariantURLSwitching() {
                const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
                if (!variantPicker) return;

                variantPicker.setAttribute('data-update-url', 'false');
            }

            removeDOMElements() {
                const pickupAvailability = this.productElement.querySelector('pickup-availability');
                if (pickupAvailability) pickupAvailability.remove();

                const productModal = this.productElement.querySelector('product-modal');
                if (productModal) productModal.remove();

                const modalDialog = this.productElement.querySelectorAll('modal-dialog');
                if (modalDialog) modalDialog.forEach((modal) => modal.remove());
            }

            preventDuplicatedIDs() {
                const sectionId = this.productElement.dataset.section;
                this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
                this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
                    element.dataset.originalSection = sectionId;
                });
            }

            removeGalleryListSemantic() {
                const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
                if (!galleryList) return;

                galleryList.setAttribute('role', 'presentation');
                galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
            }

            updateImageSizes() {
                const product = this.modalContent.querySelector('.product');
                if (product) {
                    const desktopColumns = product.classList.contains('product--columns');
                    if (!desktopColumns) return;

                    const mediaImages = product.querySelectorAll('.product__media img');
                    if (!mediaImages.length) return;

                    let mediaImageSizes =
                        '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

                    if (product.classList.contains('product--medium')) {
                        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
                    } else if (product.classList.contains('product--small')) {
                        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
                    }

                    mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
                }
            }
        }
    );
}
